/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Earsiv_TitleInputs */

const tr_landing_telegram_mock_earsiv_title = /** @type {(inputs: Landing_Telegram_Mock_Earsiv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ARŞİV FATURA`)
};

const en_landing_telegram_mock_earsiv_title = /** @type {(inputs: Landing_Telegram_Mock_Earsiv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ARCHIVE INVOICE`)
};

const de_landing_telegram_mock_earsiv_title = /** @type {(inputs: Landing_Telegram_Mock_Earsiv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ARCHIV-RECHNUNG`)
};

const ru_landing_telegram_mock_earsiv_title = /** @type {(inputs: Landing_Telegram_Mock_Earsiv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Э-АРХИВНЫЙ СЧЁТ`)
};

/**
* | output |
* | --- |
* | "E-ARCHIVE INVOICE" |
*
* @param {Landing_Telegram_Mock_Earsiv_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_earsiv_title = /** @type {((inputs?: Landing_Telegram_Mock_Earsiv_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Earsiv_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_earsiv_title(inputs)
	if (locale === "de") return de_landing_telegram_mock_earsiv_title(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_earsiv_title(inputs)
	return tr_landing_telegram_mock_earsiv_title(inputs)
});